[
  { "label": "Work", "value": "work" },
  { "label": "Personal", "value": "personal" },
  { "label": "Agent", "value": "agent" },
  { "label": "Guardian / Parent", "value": "guardian" },
  { "label": "Other", "value": "other" }
]
